/* PSW: a galeria do produto mostra so as fotos da cor escolhida (como a True Classic).
   Usa o mapa variante -> foto que ja existe no JSON [data-json] do DG Buy box.
   Fotos sem cor ligada so aparecem quando a cor escolhida nao tem nenhuma foto propria. */
(function () {
  function init(root) {
    if (root.dataset.pswGal) return;
    var jsonEl = root.querySelector('[data-json]');
    var wrap = root.querySelector('[data-slides]');
    if (!jsonEl || !wrap) return;
    root.dataset.pswGal = '1';
    var data = JSON.parse(jsonEl.textContent);
    if (data.c < 0) return;

    var colorOf = {};
    data.v.forEach(function (v) { if (v.m && !colorOf[v.m]) colorOf[v.m] = v.o[data.c]; });
    var slides = [].slice.call(wrap.children);
    var thumbs = [].slice.call(root.querySelectorAll('[data-thumb]'));
    var arrows = [].slice.call(root.querySelectorAll('[data-step]'));

    function apply(color) {
      var has = slides.some(function (s) { return colorOf[s.dataset.media] === color; });
      var shown = 0;
      slides.forEach(function (s, i) {
        var on = !has || colorOf[s.dataset.media] === color;
        s.hidden = !on;
        if (thumbs[i]) {
          thumbs[i].hidden = !on;
          thumbs[i].classList.toggle('is-active', on && shown === 0);
        }
        if (on) shown++;
      });
      arrows.forEach(function (a) { a.style.display = shown > 1 ? '' : 'none'; });
      wrap.scrollLeft = 0;
    }

    apply(data.color);
    root.querySelectorAll('.dgb__card[data-color]').forEach(function (b) {
      b.addEventListener('click', function () {
        var c = b.dataset.color;
        setTimeout(function () { apply(c); }, 0);
      });
    });
  }

  function initAll() { document.querySelectorAll('[data-dg-buy]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
